export const SIDENAV_WIDTH = 260;
export const SIDENAV_MINI_WIDTH = 80;
export const SIDENAV_GAP = 16;
export const SIDENAV_BREAKPOINT = "xl";
export const SIDENAV_PREFERENCE_KEY = "sidenavPreference";
